export default // SSE解析器类，支持流式数据处理
class SSEParser {
    private buffer = ''
    private parsedEvents: any[] = []

    parseChunk(chunk: string): any[] {
        // 将新数据添加到缓冲区
        this.buffer += chunk
        const newEvents: any[] = []

        // 按双换行分割事件
        const events = this.buffer.split('\n\n')

        // 保留最后一个可能不完整的事件
        this.buffer = events.pop() || ''

        for (const event of events) {
            if (!event.trim()) continue

            const parsedEvent = this.parseEvent(event)
            if (parsedEvent) {
                newEvents.push(parsedEvent)
                this.parsedEvents.push(parsedEvent)
            }
        }

        return newEvents
    }

    private parseEvent(event: string): any | null {
        let data: string | null = null
        const lines = event.split('\n')

        for (const line of lines) {
            if (line.startsWith('data:')) {
                data = line.replace('data:', '').trim()
            }
        }

        if (!data) return null

        try {
            return JSON.parse(data)
        } catch (e) {
            // 记录解析错误但不阻断流程
            console.warn('SSE数据解析失败:', data, e)
            return null
        }
    }

    // 获取所有已解析的事件
    getAllEvents(): any[] {
        return [...this.parsedEvents]
    }

    // 检查是否有未处理的缓冲区数据（可能是最后一个不完整的事件）
    hasBufferedData(): boolean {
        return this.buffer.trim().length > 0
    }

    // 强制处理缓冲区中的剩余数据（用于流结束时）
    flushBuffer(): any | null {
        if (!this.buffer.trim()) return null

        const event = this.parseEvent(this.buffer)
        if (event) {
            this.parsedEvents.push(event)
        }
        this.buffer = ''
        return event
    }

    // 重置解析器状态
    destroy() {
        this.buffer = ''
        this.parsedEvents = []
    }

    reset() {
        this.buffer = ''
        this.parsedEvents = []
    }
}
